module.exports = __webpack_public_path__ + "static/media/blender.ce987fa1.svg";